module.exports = __webpack_public_path__ + "b5a54acf3362cdd968adf131266a1fa3.MP3";